export const useNavbarVisibility = () => {
  const isNavbarVisible = useState('isNavbarVisible', () => true)
  // Navbar always visible - scroll handlers removed

  return { isNavbarVisible }
}
